import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import {IOfferDetailsModel} from "../../../../../../models/offer/IOfferDetailsModel";
import * as s from "./offer-quote.scss";
import {OfferService} from "../../../../../../services/offer/OfferService";
import {OfferContentComponent} from "../content/OfferContentComponent";
import {OfferPriceComponent} from "../price/OfferPriceComponent";
import {
    VisualInputStatesComponent
} from "../../../../../components/visual/input/states/VisualInputStatesComponent";
import {Resources} from "../../../../../../resources/Resources";
import {OfferTemplateIconComponent} from "../template/icon/OfferTemplateIconComponent";
import {
    ButtonCheckBoxComponent
} from "../../../../../components/global/buttons/check/box/ButtonCheckBoxComponent";
import {Network} from "../../../../../../network/Network";
import {
    LoaderLightComponent
} from "../../../../../components/global/loader/light/LoaderLightComponent";
import {IOfferProductModel} from "../../../../../../models/offer/product/IOfferProductModel";
import {IOfferProductBundleModel} from "../../../../../../models/offer/product/bundles/IOfferProductBundleModel";
import {
    dateFormat
} from "../../../../../../sedestral/framework/utilities/DateFormat";
import {OfferPaymentActionType} from "../../../../../../models/offer/payment/OfferPaymentActionType";
import {OfferState} from "../../../../../../models/offer/OfferState";
import {IOfferModel} from "../../../../../../models/offer/IOfferModel";
import {SiteAddressComponent} from "../../site/address/SiteAddressComponent";
import {AccountSessionService} from "../../../../../../services/account/session/AccountSessionService";
import {EntityService} from "../../../../../../services/entity/EntityService";
import {PaymentProvider, PaymentProviderType} from "../../../../../../models/payment/PaymentProviderType";
import {OfferContents} from "../content/types/OfferContents";
import {
    IOfferProductBundleTemplateModel
} from "../../../../../../models/offer/product/bundles/IOfferProductBundleTemplateModel";
import {SedestralProactiveMeta} from "../../../../../../sedestral/framework/proactive/ads/meta/SedestralProactiveMeta";
import {SedestralProactiveGoogle} from "../../../../../../sedestral/framework/proactive/analytics/google/SedestralProactiveGoogle";
import {OfferProductSolutionType} from "../../../../../../models/offer/product/solution/OfferProductSolutionType";
import {CommunityService} from "../../../../../../services/community/CommunityService";
import {CommunityType} from "../../../../../../models/community/types/CommunityType";
import {AlertComponent} from "../../alert/AlertComponent";

export class OfferQuoteComponent extends Component {

    public quote: IOfferDetailsModel;
    public product: IOfferProductModel;
    public bundle: IOfferProductBundleModel;
    public bundleTemplate: IOfferProductBundleTemplateModel;

    public backButton: Component;
    public priceComponent: OfferPriceComponent;

    public advantageCode: VisualInputStatesComponent;
    public cgvButton: ButtonCheckBoxComponent;
    public addressComponent: SiteAddressComponent;

    public paymentProvider: PaymentProvider;
    public displayPromoCodeInput: boolean;
    public downgradeMessage: string;

    constructor(quote: IOfferDetailsModel) {
        super();
        this.quote = quote;
        this.paymentProvider = EntityService.activeSite.paymentProvider;
        this.displayPromoCodeInput = EntityService.activeEntity.displayPromoCodeInput ?? false;

        this.product = this.quote.offer.product;
        this.bundle = this.quote.offer.product.bundle;
        this.bundleTemplate = this.quote.offer.product.template.bundle;

        //language=HTML
        this.template = `
            <div class="${s.componentOfferQuote}"></div>`;
    }

    commit() {
        this.renderAll();

        this.scrollable();
        super.commit();
    }

    renderAll() {
        this.renderBack(Resources.t(`words.offerBack`));
        this.renderAddress();
        this.renderAdvantageCode();

        if (this.quote.offer.startDate > Date.now() && EntityService.activeOfferProduct) {
            this.renderScheduled();
        }

        if (EntityService.activeOfferProduct) {
            this.renderDowngradeCheck();
        }

        this.renderOfferContent();
        this.renderPrice();

        const amount = (this.quote.payment?.currentPriceTotal ?? this.quote.offer.totalPrice) / 100;
        SedestralProactiveMeta.trackInitiateCheckout(amount, Resources.currency.code);
    }

    renderDowngradeCheck() {
        const communitySolution = this.bundle.solutions
            .find(solution => solution.type == OfferProductSolutionType.COMMUNITY);

        if (!communitySolution) {
            return;
        }

        const maxAllowed = communitySolution.quantity;

        CommunityService.findBySite(EntityService.activeSite.id, CommunityType.BLOG, this).then(communities => {
            const currentCount = communities?.length ?? 0;

            if (currentCount > maxAllowed) {
                const sitesToDelete = currentCount - maxAllowed;

                let message = Resources.r("words.offerDowngradeTooManySites", {
                    currentCount: currentCount,
                    maxAllowed: maxAllowed,
                    sitesToDelete: sitesToDelete
                });

                if (this.quote.offer.nextBilling) {
                    const nextBillingDate = dateFormat(new Date(this.quote.offer.nextBilling));
                    message += " " + Resources.r("words.offerDowngradeNextBilling", {date: nextBillingDate});
                }

                this.downgradeMessage = message;

                const alertComponent = new AlertComponent({
                    message: message,
                    margin: true,
                    big: false,
                    blue: true
                });

                this.prepend(`<div class="${s.downgradeAlert}"></div>`);
                this.el(s.downgradeAlert).render(alertComponent);
            }
        });
    }

    renderBack(text: string) {
        if (!this.quote.offer.active) {
            //language=HTML
            this.backButton = this.append(`
                <div class="${s.back}">
                    <div class="${s.icon}"></div>
                    ${text}
                </div>
            `);
            this.backButton.onClick(async () => this.back());
        } else {
            this.append(`
            <div class="${s.back}"></div>
        `);
        }
    }

    renderOfferContent() {
        let contents = this.bundle.solutions
            .filter(solution => solution.type > 0)
            .filter(solution => !OfferContents.hiddenTypes().includes(solution.type))
            .filter(solution => solution.quantity > 0)
            .map(solution => OfferContents.solutionSummary(this.product.template.type, solution));

        //language=HTML
        this.append(`
            <div class="${s.contentContainer}">
                <div class="${s.template}">
                    <div class="${s.name}">
                        ${Resources.t(`words.offerContentRecap`)}
                        ${Resources.t(`words.offerName${this.product.template.type}`)}
                    </div>
                </div>
                ${this.draw(new OfferContentComponent(OfferContents.contents(contents, this.product.template)))}
            </div>
        `);
    }

    renderAddress() {
        this.cgvButton = new ButtonCheckBoxComponent(false);
        this.addressComponent = new SiteAddressComponent();

        //language=HTML
        this.append(`
            <div class="${s.inputs}">
                ${this.paymentProvider.address ? `
                <div class="${s.label}">
                    ${Resources.t("words.offerWriteAddress")}
                </div>
                ${this.draw(this.addressComponent)}
            ` : ''}

                <div class="${s.label}">
                    <a href="${Network.router.pages.getWebsiteUrl('cgv')}" target="_blank">
                        ${Resources.t("words.offerCgv")}
                    </a>
                    <span>${this.draw(this.cgvButton)}</span>
                </div>
            </div>
        `);
    }

    renderAdvantageCode() {
        this.advantageCode = new VisualInputStatesComponent({placeholder: Resources.t("words.offerApplyAdvantageCodeInput")});

        //language=HTML
        this.append(`
            <div class="${s.advantageCode}">
                ${this.displayPromoCodeInput ? `
                    <div>${Resources.t("words.offerApplyAdvantageCode")}</div>
                    <div class="${s.inputContainer}">
                        ${this.draw(this.advantageCode)}
                    </div> ` : ''}
            </div>`);
    }

    renderScheduled() {
        //language=HTML
        this.append(`
            <div class="${s.scheduled}">
                ${Resources.t("words.offerTakeEffectAt")} ${dateFormat(new Date(this.quote.offer.startDate))}
            </div>
        `);
    }

    renderPrice(fixedPrice?: number, text?: string) {
        this.priceComponent = new OfferPriceComponent({
            period: {
                periodType: this.quote.offer.periodType,
                advantagePercentage: this.quote.offer.advantagePercentage
            },
            price: fixedPrice ? fixedPrice : this.quote.offer.totalPrice,
            noCalculateYear: true,
            text: text ? text : Resources.t("words.continue"),
            totalPrice: fixedPrice != undefined
        });
        this.priceComponent.onGetStarted = async () => this.getStarted();

        //language=HTML
        this.append(`
            <div class="${s.priceBottom}">
                ${this.draw(this.priceComponent)}
            </div>
        `);
    }

    async back() {
        this.clearAll();
        this.render(new LoaderLightComponent());
        await OfferService.quoteCancel(this);
        this.onStep();
    }

    async getStarted() {
        if (this.downgradeMessage) {
            Network.router.static.components.notifications.notify(this.downgradeMessage, undefined, 30000, "error");
            return;
        }
        if (!this.cgvButton.checked) {
            Network.router.static.components.notifications.notify(Resources.t("words.offerAcceptCgv"), undefined, 3000);
        } else if (this.paymentProvider.address && !this.addressComponent.check()) {
            Network.router.static.components.notifications.notify(Resources.t("words.errorFillEmptyFieldsError"), undefined, 3000);
        } else {
            this.priceComponent.setLoading();

            let quote = await OfferService.quoteConfirmed({
                offerId: this.quote.offer.id,
                address: this.paymentProvider.address ? this.addressComponent.getAddress() : undefined,
                advantageCode: this.displayPromoCodeInput && this.advantageCode.getValue().length > 0 ? this.advantageCode.getValue() : undefined
            }, this);

            if (quote) {

                await AccountSessionService.token();

                if (this.paymentProvider.id == PaymentProviderType.STRIPE && quote.payment?.actionType == OfferPaymentActionType.NONE) {
                    await this.startStripePayCheck(quote.offer);
                } else {
                    this.onStep(quote);
                    this.priceComponent.remLoading();
                }

            } else {
                this.priceComponent.remLoading();
            }
        }
    }

    scheduleExpiredQuote() {
        if (this.quote.offer.expiredTime > 0) {
            let time = this.quote.offer.expiredTime - Date.now();
            this.timeOut(() => this.back(), time);
        }
    }

    async startStripePayCheck(offerQuote: IOfferModel) {

        if (offerQuote.state === OfferState.SCHEDULED) {
            this.trackConversion();
            this.onCloseModal();
            Network.router.static.components.notifications.notify(Resources.t("words.offerNowScheduled"), undefined, 3000, "success");
            await this.reloadSubscriptionPage();
        } else {

            let intervalCount = 0;
            this.interval(async () => {

                if (intervalCount >= 3) {
                    Network.router.static.components.notifications.notify(Resources.t("words.errorMessage"), undefined, 3000);
                    this.clearIntervals();
                    this.priceComponent.remLoading();
                    return;
                }

                intervalCount++;

                let offerDetails = await OfferService.active(false, this);
                if (offerDetails && offerDetails.offer.id == offerQuote.id) {
                    this.clearIntervals();
                    this.trackConversion();
                    this.onCloseModal();
                    Network.router.static.components.notifications.notify(Resources.t("words.offerNowActive"), undefined, 3000, "success");
                    await this.reloadSubscriptionPage();
                }
            }, 7000);

            this.priceComponent.setLoading();
        }
    }

    trackConversion() {
        const amount = (this.quote.payment?.currentPriceTotal ?? this.quote.offer.totalPrice) / 100;
        SedestralProactiveMeta.trackPurchase(amount, Resources.currency.code);
        SedestralProactiveGoogle.trackPurchase(amount, this.quote.offer.id, Resources.currency.code);
    }

    onStep(details?: IOfferDetailsModel) {

    }

    onCloseModal() {

    }

    async reloadSubscriptionPage() {
        window.location.href = "/b/home/content/subscriptions/home"
    }
}